// src/pages/CheckoutFailure.js
import { useNavigate } from "react-router-dom";
import failGif from "./failure.gif"; // Add a fail animation or static image


const CheckoutFailure = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      {/* Header */}
      {/* <header style={styles.header}>
        <img src={logo} alt="Shreenath Foods" style={styles.logo} />
        <h1 style={styles.title}>Shreenath Foods</h1>
      </header> */}

      {/* Content */}
      <div style={styles.content}>
        <img
          src={failGif}
          alt="Failed Payment"
          style={{ width: "180px", marginBottom: "30px" }}
        />
        <h2 style={{ fontSize: "28px", color: "#c1121f" }}>Payment Failed</h2>
        <p style={styles.subtitle}>
          Something went wrong during your transaction. Please try again later or use a different payment method.
        </p>

        <button
          style={styles.button}
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default CheckoutFailure;

const styles = {
  container: {
    fontFamily: "'Poppins', sans-serif",
    minHeight: "100vh",
    background: "linear-gradient(145deg, #fffdf7, #f9f3ea)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent:'center',

    paddingTop: "50px",
  },
  header: {
    display: "flex",

    gap: "15px",
    marginBottom: "40px",
  },
  logo: {
    height: "60px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "#a6141e",
  },
  content: {
    textAlign: "center",
    background: "#fff",
    padding: "40px 30px",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    maxWidth: "600px",
    width: "90%",
  },
  subtitle: {
    fontSize: "16px",
    color: "#555",
    margin: "20px 0",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#a6141e",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s",
  },
};
